import { FlexView } from '@cuemath/comps';
import { Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import LAYOUT from 'constants/layout';
import useLogic from './AutoMappingModal.logic';
import AutoMappingForm from './auto-mapping-form';
import MappingResult from './mapping-result';

const { GAP, GUTTER } = LAYOUT;

const AutoMappingModal = () => {
  const { handleSubmit, submitLoader, mappingSearchResult } = useLogic();

  return (
    <FlexView gutter={GUTTER} gap={GAP}>
      <Text variant="h4">Auto mapping</Text>
      <Separator height={24} />
      {mappingSearchResult ? (
        <MappingResult result={mappingSearchResult} />
      ) : (
        <AutoMappingForm handleSubmit={handleSubmit} submitLoader={submitLoader} />
      )}
    </FlexView>
  );
};

export default AutoMappingModal;
